export default __webpack_public_path__ + "static/media/documents.c4e4577d.svg";